export default {
    INIT_LOGGED_CUSTOMER: function (state, data) {
        state.loggedCustomer = data.loggedCustomer;
    }
};
